'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
const NewFunctionWizard = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/NewFunctionWizard'));
export default function withNewFunctionWizard(WrappedComponent) {
  class HighOrderWithNewFunctionWizard extends Component {
    constructor(props) {
      super(props);

      this.componentDidUpdate = prevProps => {
        if (this.props.folderId !== prevProps.folderId) {
          this.setState({
            folderId: this.props.folderId
          });
        }
      };

      this.handleNewFunctionCallback = () => {
        this.setState({
          open: false
        });
      };

      this.handleNewFunctionClick = () => {
        this.setState({
          open: true
        });
      };

      this.renderNewFunctionWizard = () => {
        if (!this.state.open) {
          return null;
        }

        return /*#__PURE__*/_jsx(NewFunctionWizard, {
          callback: this.handleNewFunctionCallback,
          folderId: this.state.folderId,
          onFolderChange: evt => {
            this.setState({
              folderId: evt.target.value.id
            });
          }
        });
      };

      this.state = {
        open: false,
        folderId: props.folderId
      };
    }

    render() {
      const renderedNewFunctionWizard = this.renderNewFunctionWizard();
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        NewFunctionWizard: renderedNewFunctionWizard,
        onNewFunctionClick: this.handleNewFunctionClick
      }));
    }

  }

  HighOrderWithNewFunctionWizard.propTypes = {
    folderId: FolderPropTypes.folderId
  };
  HighOrderWithNewFunctionWizard.defaultProps = {
    folderId: null
  };
  return HighOrderWithNewFunctionWizard;
}